module.exports = __webpack_public_path__ + "static/media/person-active.da70998d.svg";